app.service('deliveryInputs', function (console, loading, deliveryValidateCity, select) {
	var $self, $form, $deliveryAddress, $invoiceAddress, $companyName, $invoiceCompanyName, $invoiceUserName, 
	$nip, $invoiceNipLabel, $invoiceNip, $pesel, $invoicePesel;

	function deliveryAddressSwitch(address) {
		console.log('deliveryAddressSwitch');
		$('#delivery-street').val(address.street);
		$('#delivery-house-number').val(address.houseNumber);
		$('#delivery-flat-number').val(address.flatNumber);
		$('#delivery-zip-code').val(address.zipCode);
		$('#delivery-city-name').val(address.city);
	}
	function receiverDataSwitch(data) {
		console.log('receiverDataSwitch');
		$('#receiver-firstname').val(data.firstname);
		$('#receiver-surname').val(data.surname);
		$('#receiver-phone').val(data.phone);
	}

	function invoiceAddressSwitch(address) {
		console.log('invoiceAddressSwitch');
		$('#invoice-firstname').val(address.addLine1);
		$('#invoice-surname').val(address.addLine2);
		$('#invoice-street').val(address.street);
		$('#invoice-house-number').val(address.houseNumber);
		$('#invoice-flat-number').val(address.flatNumber);
		$('#invoice-zip-code').val(address.zipCode);
		$('#invoice-city-name').val(address.city);
		$('#invoice-company-name-textarea-div').text(address.companyName).trigger('input');
		$('#invoice-nip').val(address.nip).trigger('input');
		const countryCode = address.countryCode || "PL";
		const $invoiceCountryCode = $('#invoice-country-code');
		select.setValue({ $input: $invoiceCountryCode, value: countryCode });
		$invoiceCountryCode.data('prev-value', countryCode);
	}
	function checkAddress(deliveryEqualsHome) {
		$deliveryAddress.disabled(false);
		if (deliveryEqualsHome) {
			$self.addClass('hide-another-delivery-address');
			$deliveryAddress.ignore(true);
		} else {
			$self.removeClass('hide-another-delivery-address');
			$deliveryAddress.ignore(false);
		}
	}
	function checkName(frontUserType) {
		if (frontUserType == 'COMPANY') {
			$self.removeClass('hide-company-name');
			$companyName.ignore(false);
		} else {
			$self.addClass('hide-company-name');
			$companyName.ignore(true).val('');
		}
	}
	function checkInvoice(invoiceNeeded) {
		if (invoiceNeeded) {
			$self.removeClass('hide-invoice-data');
			$invoiceAddress.ignore(false);
		} else {
			$self.addClass('hide-invoice-data');
			$invoiceAddress.ignore(true);
		}
	}
	function checkReceiver(sameReceiver) {
		if (sameReceiver) {
			$self.addClass('hide-receiver-data');
			$receiverAddress.ignore(true);
		} else {
			$self.removeClass('hide-receiver-data');
			$receiverAddress.ignore(false);
		}
	}
	function checkEuTaxIdPurchase(frontUserType) {
		if (frontUserType == 'COMPANY') {
			$self.addClass('hide-eu-tax-id-purchase');
			$('#euTaxIdPurchase').prop('checked', false);
		} else {
			$self.removeClass('hide-eu-tax-id-purchase');
		}
	}

	function checkInvoiceName(invoiceNeeded, frontUserType) {
		if (invoiceNeeded) {
			if (frontUserType == 'COMPANY') {
				$invoiceCompanyName.ignore(false);
				$invoiceUserName.ignore(true).cleanValid();

				$self.removeClass('hide-invoice-company-box');
				$self.addClass('hide-invoice-name-box');
			} else {
				$invoiceCompanyName.ignore(true).val('').cleanValid();
				$invoiceUserName.ignore(false);

				$self.addClass('hide-invoice-company-box');
				$self.removeClass('hide-invoice-name-box');
			}
		}
	}

	function checkPesel(frontUserType) {
		if (frontUserType == 'COMPANY') {
			$self.addClass('hide-pesel-box');
			$pesel.ignore(true);
			$invoicePesel.ignore(true);
		} else {
			$self.removeClass('hide-pesel-box');
			$pesel.ignore(false);
			$invoicePesel.ignore(false);
		}
	}
	function checkNip(invoiceNeeded, frontUserType) {
		if (invoiceNeeded) {
			$invoiceNipLabel.html('NIP<em>*</em>');
			$self.addClass('hide-company-nip');
			$invoiceNip.ignore(false);
			//Przepisz nip z danych do faktury
			// if($invoiceNip.val()==='' && $nip.val()!==''){
			// 	$invoiceNip.val($nip.val());
			// 	$nip.val('').cleanValid();
			// }
			if (frontUserType == 'COMPANY') {
				$nip.ignore(false);
				$self.removeClass('hide-company-nip')
				$invoiceNip.rules('add', 'required');
			} else {
				$nip.ignore(true).val('').trigger('input');
				$invoiceNipLabel.text('NIP');
				$invoiceNip.rules('remove', 'required');
			}
		} else {
			//Przepisz nip z danych użytkownika
			// if($invoiceNip.val()!=='' && $nip.val()==='') {
			// 	$nip.val($invoiceNip.val());
			// 	$invoiceNip.val('').cleanValid();
			// }
			if (frontUserType == 'COMPANY') {
				$self.removeClass('hide-company-nip');
				$nip.ignore(false);
				$invoiceNip.ignore(true);
			} else {
				$self.addClass('hide-company-nip');
				$nip.ignore(true).val('').trigger('input');
				$companyName.val('');
			}
		}
	}
	
	function checkTaxfree(option) { 
		if (option.taxfree) {
			$self.addClass('taxfree-enabled');
		} else {
			$self.removeClass('taxfree-enabled');
		}
	}
	function checkProductWithCoupon(option) { 
		if (option.productWithCoupon) {
			$self.addClass('product-with-coupon-enabled');
		} else {
			$self.removeClass('product-with-coupon-enabled');
		}
	}
	function shopPrevalidate(option) {
		var invoiceMode = option.showInvoiceData && option.invoiceNeeded;
		checkTaxfree(option);
		checkProductWithCoupon(option);
		checkName(option.frontUserType);	//dodałem gdy dla sklepu zmieniamy kupuję jako i zaczeły pojawiać się dane firmy
		checkEuTaxIdPurchase(option.frontUserType);
		//rozwijanie danych do faktury + standardowa walidacja
		checkInvoice(invoiceMode);
		//rozwijanie danych odbiorcy + standardowa walidacja
		checkReceiver(option.sameReceiver);
		//pokazywanie imie/nazwisko/firma w Danych do faktury
		checkInvoiceName(invoiceMode, option.frontUserType);
		//wszystkie akcje do PESEL
		checkPesel(option.frontUserType);

		//wszystkie akcje do NIP
		checkNip(invoiceMode, option.frontUserType);
		

	}
	function homePrevalidate(option) {
		//dane dostawy
		var invoiceMode = option.showInvoiceData && option.invoiceNeeded;
		checkAddress(option.deliveryEqualsHome);
		//pokazywanie imie/nazwisko/firma w Twoich danych
		checkName(option.frontUserType);
		checkEuTaxIdPurchase(option.frontUserType);
		//rozwijanie danych do faktury + standardowa walidacja
		checkInvoice(invoiceMode);
		$('#invoice-box input[value=' + invoiceMode + ']').not('#euTaxIdPurchase').prop('checked', true);
		//rozwijanie danych odbiorcy + standardowa walidacja
		checkReceiver(option.sameReceiver);
		//pokazywanie imie/nazwisko/firma w danych do faktury
		checkInvoiceName(invoiceMode, option.frontUserType);
		//wszystkie akcje do PESEL
		checkPesel(option.frontUserType);
		//wszystkie akcje do NIP
		checkNip(invoiceMode, option.frontUserType);
	}
	function prevalidate(option) {
		if (option.deliveryType == 'shop') {
			shopPrevalidate(option);
		} else {
			homePrevalidate(option);
		}
	}
	function validate(config) {
		if ($form.valid()) {
			loading.start();
			if (config.deliveryInfo.deliveryEqualsHome) {
				deliveryAddressSwitch({
					street: $('#home-address-street').val(),
					houseNumber: $('#home-house-number').val(),
					flatNumber: $('#home-flat-number').val(),
					zipCode: $('#zip-code').val(),
					city: $('#city-name').val()
				});
			}
			if (!config.deliveryInfo.invoiceNeeded && config.deliveryInfo.deliveryType === 'home') {	//jeśli potrzebna inna faktura i nie jest to distawa do sklepu
				invoiceAddressSwitch({
					addLine1: $('#firstname').val(),
					addLine2: $('#surname').val(),
					street: $('#home-address-street').val(),
					houseNumber: $('#home-house-number').val(),
					flatNumber: $('#home-flat-number').val(),
					zipCode: $('#zip-code').val(),
					countryCode: $('#country-code').val(),
					city: $('#city-name').val(),
					companyName: $('#company-name-textarea-div').text(),
					nip: $('#nip').val()
				});
			}
			deliveryValidateCity.validate(config);
		} else {
			console.log('formularz ma błędy', $('.error'));
		}
	}

	function setElements() {
		$form = $('#choose-delivery-form', $self);
		$deliveryAddress = $('#delivery-address input:not(#delivery-flat-number)', $form);
		$invoiceAddress = $('#invoice-data input:not(#invoice-flat-number), #invoice-data textarea', $form);
		$receiverAddress = $('#receiver-data input', $form);
		$companyName = $('#company-name-textarea', $form);
		$invoiceCompanyName = $('#invoice-company-name-textarea', $form);
		$invoiceUserName = $('#invoice-surname, #invoice-firstname', $form);
		$nip = $('#nip', $form);
		$invoiceNip = $('#invoice-nip', $form);
		$invoiceNipLabel = $invoiceNip.prev();
		$pesel = $('#pesel-box .js-pesel', $form);
		$invoicePesel = $('#invoice-pesel-box .js-pesel', $form);
	}

	function setEvents() {
	}

	function init(self) {
		$self = self;
		setElements();
		setEvents();
	}
	return {
		init,
		deliveryAddressSwitch,
		receiverDataSwitch,
		invoiceAddressSwitch,
		prevalidate,
		validate
	};
});
